import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { api } from "@/lib/api-client"

export interface CalendarEvent {
  id: string
  type: "task" | "activity"
  title: string
  date: string
  time: string | null
  end_time: string | null
  all_day: boolean
  status?: string
  priority?: string
  task_type?: string
  activity_type?: string
  user: { id: string; first_name: string; last_name: string } | null
  entity_url: string
}

interface CalendarFilters {
  start_date: string
  end_date: string
  user_id?: string
}

export function useCalendarEvents(filters: CalendarFilters) {
  return useQuery({
    queryKey: ["calendar", filters],
    queryFn: () => {
      const params = new URLSearchParams()
      params.set("start_date", filters.start_date)
      params.set("end_date", filters.end_date)
      if (filters.user_id) params.set("user_id", filters.user_id)
      return api.get<{ data: CalendarEvent[] }>(`/api/v1/calendar?${params}`)
    },
  })
}

export function useReschedule() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: { id: string; type: string; date: string; time?: string }) =>
      api.patch("/api/v1/calendar/reschedule", data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["calendar"] })
      qc.invalidateQueries({ queryKey: ["tasks"] })
    },
  })
}
